<template>
  <v-container fill-height>
    <v-row justify="center" v-if="!loading">
      <v-col cols="10" lg="8" align="center">
        <v-img width="200px" height="75px" :src="`${ require('@/assets/stripe-logo-blue.svg') }`"></v-img>
      </v-col>
      <v-col cols="10" lg="5" v-if="userProfile.stripeAuthStatus ==='pending'">
        {{ $language.registration["Pending Authorization"] }}
        <v-progress-linear indeterminate></v-progress-linear>
      </v-col>
      <v-col cols="10">
        <div class="mt-3 subheading text-center font-weight-bold grey--text" v-if="hasStripe&&!payoutsEnabled">
          {{$language.registration["First stripe step complete"] }}
        </div>
        <div class="mt-3 subheading text-center font-weight-bold grey--text text-left" v-if="hasStripe&&payoutsEnabled">
          {{$language.registration["Stripe complete"] }}
        </div>
      </v-col>
      <v-col cols="10">
        <v-btn v-if="!hasStripe&&!payoutsEnabled&&userProfile.stripeAuthStatus !=='pending'" @click="stripeSignup" block large color="primary">
          <span class="white--text">{{ $language.registration["Set up payments on stripe"] }}</span>
        </v-btn>
      </v-col>
      <v-col cols="10">
        <v-btn v-if="hasStripe&&!payoutsEnabled&&userProfile.stripeAuthStatus !=='pending'" @click="createLink" block large color="error">
          <span class="white--text">{{ $language.registration["Check your status"] }}</span>
          <v-progress-circular indeterminate v-if="(userProfile.balances || false).waitingForUrl || false" class="ml-4" color="white"></v-progress-circular>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-else justify="center">
      <v-col cols="12" align="center">
        <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {
  mapState
} from 'vuex'
const fb = require('@/services/firebaseConfig.js')
export default {

  data () {
    return {
      loading: true
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'categories']),

    hasStripe () {
      var pending = (((this.userProfile || {}).stripeAccount || {}).account || false)
      return pending
    },
    payoutsEnabled () {
      var pending = ((((this.userProfile || {}).stripeAccount || {}).account || {}).payouts_enabled || false)
      return pending
    },
    url () {
      if (this.userProfile.balances) {
        return this.userProfile.balances.url
      }
      return null
    }

  },
  methods: {
    stripeSignup () {
      // dev
      window.location.href = `https://dashboard.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_CNBjx860hxJ1ujCiC0yawQB6oyE0TFaH&stripe_user[first_name]=${this.userProfile.public.firstName}&stripe_user[last_name]=${this.userProfile.public.lastName}&stripe_user[email]=test${this.userProfile.public.email}&stripe_user[phone_number]=0000000000&scope=read_write&redirect_uri=http://localhost:8080/stripe-registration`
      // test
      // window.location.href = `https://dashboard.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_CNBjx860hxJ1ujCiC0yawQB6oyE0TFaH&stripe_user[first_name]=${this.userProfile.public.firstName}&stripe_user[last_name]=${this.userProfile.public.lastName}&stripe_user[email]=test${this.userProfile.public.email}&stripe_user[phone_number]=0000000000&scope=read_write&redirect_uri=http://jefe-vue.firebaseapp.com/stripe-registration`
      // prod
      window.location.href = `https://dashboard.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_CNBjvPagvg5ImtTPpEpbScvmuWig3SMS&stripe_user[first_name]=${this.userProfile.public.firstName}&stripe_user[last_name]=${this.userProfile.public.lastName}&stripe_user[email]=${this.userProfile.public.email}&stripe_user[phone_number]=${this.userProfile.public.mobilePhone}&scope=read_write&redirect_uri=https://hefeapp.com/stripe-registration`
    },
    createLink () {
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/balances/getNewURL`] = new Date()
      updates[`user/${this.currentUser.uid}/profile/balances/waitingForUrl`] = true
      fb.database.ref().update(updates)
    }
  },
  watch: {
    url () {
      if (this.userProfile.balances.waitingForUrl === false) {
        window.location.href = this.url
      }
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/balances/waitingForUrl`] = null
      updates[`user/${this.currentUser.uid}/profile/balances/url`] = null
      fb.database.ref().update(updates)
    }
  },
  mounted: function () {
    if (this.$route.query.code) {
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/stripeCode`] = this.$route.query.code
      updates[`user/${this.currentUser.uid}/profile/stripeAuthStatus`] = 'pending'
      fb.database.ref().update(updates)
    }
    setTimeout(() => {
      this.loading = false
    }, 1000)
  }
}
</script>
